import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  selectComponent: {
    width: '100%',
    // height: '60px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontFamily: 'Noto Sans JP',
    fontSize: '18px',
    fontWeight: 500,
    // lineHeight: '26px',
    letterSpacing: '0.8px',
    color: '#606060',
    '& .MuiMenuItem-root': {
      maxWidth: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '19px',
    },
  },

  optionComponent: {
    width: '100%',
  },
  notchedOutline: {
    // NOTE: the legend element is a child of the notchedOutline component
    '& legend': {
      maxWidth: '1000px',
    },
  },
  selectItemComponent: {
    maxWidth: '600px',
  },

}));

export default useStyles;
